import * as Sentry from '@sentry/browser';

if (process.env.NODE_ENV === 'production') {
  try {
    Sentry.init({
      release: process.env.VUE_APP_BUILD_TIME,
      environment: process.env.VUE_APP_ENVIRONMENT,
      dsn: process.env.VUE_APP_SENTRY_DSN,
      // FIXME: Sentry暂时不支持Vue3，https://github.com/getsentry/sentry-javascript/issues/2925
      // integrations: [new VueIntegration({ Vue, logErrors: true })],
    });
  } catch (error) {
    console.log('Failed to initialize sentry:', error);
  }
}
